import React from 'react'
import styles from './styles.module.scss'
import BackNavigation from 'srcReact/components/common2/BackNavigation'
import ListItem from 'srcReact/components/common2/ListItem'

const SidebarMenu = ({ isMobile, activeItem, setActiveItem, listItems }) => {
  return (
    <div className={styles.sidebarMenuWrapper}>
      {!isMobile && <BackNavigation className={styles.backNavigation} />}

      {listItems.map((l, idx) => (
        <ListItem
          key={idx}
          heading={l.heading}
          items={l.items}
          activeItem={activeItem}
          setActiveItem={setActiveItem}
          className={idx === 0 ? styles.listItems : ''}
          showIcon={isMobile}
        />
      ))}
    </div>
  )
}

export default SidebarMenu
